import { CheckIcon } from '@/atoms/Icons/CheckIcon'
import { ParagraphSM } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { CheckInputButton } from '../../components/CheckInputButton'
import { Page } from '../../components/Page'
import { PageHeading } from '../../components/PageHeading'
import { useTorchApplication } from '../../components/TorchApplicationContext'
import { useDelayedSelection } from '../../components/useDelayedSelection'
import { TORCH_APPLICATION_FEE } from '../../utils/payment'
import { TorchApplicationTypeIcon } from './TorchApplicationTypeIcon'
import { filterApprovedTorchApplications, useTorchApplicationType } from './torchApplicationHelpers'

const FREE_RESUBMISSION_ACTIVE_STATUSES = ['QUALIFIED', 'STARTED', 'IN_PROGRESS']

export const ResubmitTorch = () => {
  const { t } = useTranslate('guild-create')
  const { torchApplications, updateData, setPageStep } = useTorchApplication()
  const getTorchApplicationType = useTorchApplicationType()
  const [selection, onClick] = useDelayedSelection((id) => updateData({ originalApplicationId: id }))

  const approvedApplications = filterApprovedTorchApplications(torchApplications)

  return (
    <Page onBack={() => setPageStep(0)}>
      <div className="flex flex-col items-center gap-2">
        <PageHeading>{t('whatProjectWouldYouLikeToResubmit', 'What project would you like to resubmit?')}</PageHeading>
        <ParagraphSM weight="normal">
          {t('aSubmissionFeeMayApply', 'A {{ fee }} submission fee may apply.', { fee: TORCH_APPLICATION_FEE })}
        </ParagraphSM>
      </div>

      {approvedApplications.map((appl) => {
        if (!appl) return null

        return (
          <CheckInputButton
            key={appl.id}
            name={appl.id}
            selected={selection === appl.id}
            onClick={onClick}
            className="!w-5/6 px-3 lg:!w-2/3"
          >
            <div className="flex w-full flex-col items-center lg:flex-row lg:justify-between">
              <div className="flex items-center gap-4">
                <TorchApplicationTypeIcon type={appl.type} size={36} color="core-gray-950" />
                <div className="flex flex-col items-start">
                  <div>{appl.data?.title ?? `Unnamed Torch (${getTorchApplicationType(appl.type)})`}</div>
                  <ParagraphSM color="core-gray-500">{getTorchApplicationType(appl.type)}</ParagraphSM>
                </div>
              </div>
              {appl.data?.resubmissionStatus &&
                FREE_RESUBMISSION_ACTIVE_STATUSES.includes(appl.data.resubmissionStatus) && (
                  <div className="flex items-center gap-2">
                    <CheckIcon color="oxide" size={20} />
                    <div className="text-sm text-oxide">Free Resubmission Available</div>
                  </div>
                )}
            </div>
          </CheckInputButton>
        )
      })}
    </Page>
  )
}
